import { DeleteTasks as DefaultBulkDeleteTasksButton, DefaultBulkActionsDeleteTasksOnSuccess } from 'customer-data-bulk-actions/components/buttons/tasks/DeleteTasks';
import { useCallback } from 'react';
import { DELETE_TASK_CONFIRMATION_MODAL } from '../../constants/modalTypes';
import { TASK_INTERACTION_TYPES } from '../../constants/table';
import { useDispatch } from '../../context/Redux';
import { useTableContext } from '../../context/TableContext';
import { useTemporarilyExcludeIds } from '../../hooks/useTemporarilyExcludeIds';
import { openModalAction } from '../../redux/actions/overlay';
import { deleteAllTasks, deleteTasks, logBulkActionDelete } from '../../redux/actions/tasksCRUD';
import { jsx as _jsx } from "react/jsx-runtime";
const BulkDeleteTasksButton = ({
  selection,
  clearSelection,
  allSelected
}) => {
  const dispatch = useDispatch();
  const {
    onDelayedRefreshSearch
  } = useTableContext();
  const temporarilyExcludeTaskIds = useTemporarilyExcludeIds();
  const handleDeleteOneTask = useCallback(() => {
    dispatch(openModalAction({
      modalType: DELETE_TASK_CONFIRMATION_MODAL,
      modalData: {
        clearSelection,
        taskIds: selection
      }
    }));
  }, [clearSelection, dispatch, selection]);
  const onSuccess = useCallback(({
    count
  }) => {
    DefaultBulkActionsDeleteTasksOnSuccess({
      allSelected,
      count
    });
    if (!allSelected) {
      dispatch(deleteTasks({
        taskIds: selection
      }));
      temporarilyExcludeTaskIds(selection, TASK_INTERACTION_TYPES.DELETE_TASKS);
    } else {
      dispatch(deleteAllTasks());
    }
    onDelayedRefreshSearch();
    clearSelection();
  }, [allSelected, onDelayedRefreshSearch, clearSelection, dispatch, selection, temporarilyExcludeTaskIds]);
  return /*#__PURE__*/_jsx(DefaultBulkDeleteTasksButton, {
    buttonProps: {
      handleDeleteOneTask,
      logFunction: logBulkActionDelete,
      onSuccess
    }
  });
};
export default BulkDeleteTasksButton;